import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ENV } from "../generated-aws";
import { UserInfo } from "../models/user-info";
import { Toast } from "../services/toast-service";

type HeaderProps = {
  userInfo: UserInfo;
  hideNavigationLinks?: boolean;
};

const Header: React.FC<HeaderProps> = (props) => {
  const [name, setName] = useState<string>("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setName(props.userInfo.AuthorName);
  }, [props.userInfo]);

  const handleLogout = async () => {
    try {
      await Auth.signOut();
      Toast("Success!!", "Logged out successfully!", "success");
      navigate("/login");
    } catch (err) {
      console.error(err);
      if (err instanceof Error) {
        Toast("Error!!", err.message, "danger");
      } else {
        Toast("Error!!", "Something went wrong during logout.", "danger");
      }
    }
  };

  const renderLink = (to: string, label: string) => (
    <Link to={to}>
      <span
        className={
          to === location.pathname
            ? "text-lg font-[ApercuProBold] text-[#303030]"
            : "text-lg text-[#424242]"
        }
      >
        {label}
      </span>
    </Link>
  );

  const envNameFormatted = (envName: string) => {
    if (envName === "coders") {
      return "Sandbox";
    }
    if (envName === "dev") {
      return "Dev";
    }
    if (envName === "test") {
      return "Test";
    }
    if (envName === "master") {
      return "Production";
    }
    return envName || "";
  };

  return (
    <>
      <header className="bg-[#424242] flex justify-between px-10 py-2 mb-6">
        <div className="flex flex-1 py-1">
          <img
            src="/images/logo.svg"
            className="h-7 cursor-pointer"
            alt="The University Of Sydney"
            onClick={() => {
              props.userInfo.isCoordinator || props.userInfo.isEditor
                ? navigate("/dashboard")
                : navigate("/");
            }}
          />
        </div>
        <div className="flex items-center">
          <span className="mx-4 text-white text-sm">
            Environment: {envNameFormatted(ENV.ENV_NAME)}
          </span>
          <button
            className="text-white text-sm flex flex-row items-center"
            onClick={handleLogout}
          >
            {name}
            <img src="/images/logout.svg" className="h-5 ml-1" alt="Log out" />
          </button>
        </div>
      </header>
      {!props.hideNavigationLinks && (
        <div className="flex flex-1 justify-evenly border-b border-black pb-1 mx-10">
          {renderLink("/", "Create")}
          {renderLink("/edit", "Edit")}
          {renderLink("/approvals", "Approvals")}
          {renderLink("/academic-compose-email", "Academic Compose")}
          {/* Hide Academic Status, screen real estate needed and can get to this from Academic Compose screen
          {renderLink("/academic-email-status", "Academic Status")} */}
          {renderLink("/import-email-recipients", "Import")}
          {renderLink("/export", "Export")}
          {renderLink("/access", "Access")}
        </div>
      )}
    </>
  );
};

export default Header;
